/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TechnicalData {
  makerCode?: string;
  modelCode?: string;
  praUse?: string;
  taxableHorsePower?: number;
  weight?: number;
  vehicleLength?: number;
  vehicleWidth?: number;
  vehicleHeight?: number;
  kgTowableMass?: number;
  tractionCode?: string;
  gearBoxCode?: string;
  maxSpeed?: number;
  acceleration?: number;
  vehicleTypeFlag?: string;
  antipollutionCode?: string;
  airbagType?: TechnicalData.AirbagTypeEnum;
  altSel?: number;
  bodyType?: TechnicalData.BodyTypeEnum;
  catalogPrice?: number;
  currentCatalogPrice?: number;
  larghezza?: number;
  lunghezza?: number;
  pospne?: TechnicalData.PospneEnum;
  riskClass?: string;
  tipNor?: number;
  velMax?: number;
}
export namespace TechnicalData {
  export type AirbagTypeEnum = 'CONDUCENTE' | 'CONDUCENTE_PASSEGGERO' | 'CONDUCENTE_PASSEGGERO_LATERALI' | 'NESSUNO';
  export const AirbagTypeEnum = {
    CONDUCENTE: 'CONDUCENTE' as AirbagTypeEnum,
    CONDUCENTEPASSEGGERO: 'CONDUCENTE_PASSEGGERO' as AirbagTypeEnum,
    CONDUCENTEPASSEGGEROLATERALI: 'CONDUCENTE_PASSEGGERO_LATERALI' as AirbagTypeEnum,
    NESSUNO: 'NESSUNO' as AirbagTypeEnum,
  };
  export type BodyTypeEnum =
    | 'STATIONWAGON'
    | 'COUPE'
    | 'FURGONE'
    | 'FHT'
    | 'TORPEDO_HARD_TOP'
    | 'BERLINA_2_VOLUMI'
    | 'MULTISPAZIO'
    | 'BERLINA_3_VOLUMI'
    | 'PICKUP'
    | 'FST'
    | 'SPIDER'
    | 'SEMI_PICKUP'
    | 'TORPEDO'
    | 'HYPERSPORT'
    | 'ENDURO'
    | 'SPORT_TOURER'
    | 'TRIAL'
    | 'MOTARD'
    | 'CUSTOM_CRUISER'
    | 'SCOOTER'
    | 'NAKED'
    | 'ON_OFF'
    | 'PIT_BIKE'
    | 'OTHER_MOTO'
    | 'OLD_OTHER_MOTO'
    | 'FLAT_TRACK'
    | 'MOTORCROSS'
    | 'MINICROSS'
    | 'QUADRICICLO'
    | 'TRIKE';
  export const BodyTypeEnum = {
    STATIONWAGON: 'STATIONWAGON' as BodyTypeEnum,
    COUPE: 'COUPE' as BodyTypeEnum,
    FURGONE: 'FURGONE' as BodyTypeEnum,
    FHT: 'FHT' as BodyTypeEnum,
    TORPEDOHARDTOP: 'TORPEDO_HARD_TOP' as BodyTypeEnum,
    BERLINA2VOLUMI: 'BERLINA_2_VOLUMI' as BodyTypeEnum,
    MULTISPAZIO: 'MULTISPAZIO' as BodyTypeEnum,
    BERLINA3VOLUMI: 'BERLINA_3_VOLUMI' as BodyTypeEnum,
    PICKUP: 'PICKUP' as BodyTypeEnum,
    FST: 'FST' as BodyTypeEnum,
    SPIDER: 'SPIDER' as BodyTypeEnum,
    SEMIPICKUP: 'SEMI_PICKUP' as BodyTypeEnum,
    TORPEDO: 'TORPEDO' as BodyTypeEnum,
    HYPERSPORT: 'HYPERSPORT' as BodyTypeEnum,
    ENDURO: 'ENDURO' as BodyTypeEnum,
    SPORTTOURER: 'SPORT_TOURER' as BodyTypeEnum,
    TRIAL: 'TRIAL' as BodyTypeEnum,
    MOTARD: 'MOTARD' as BodyTypeEnum,
    CUSTOMCRUISER: 'CUSTOM_CRUISER' as BodyTypeEnum,
    SCOOTER: 'SCOOTER' as BodyTypeEnum,
    NAKED: 'NAKED' as BodyTypeEnum,
    ONOFF: 'ON_OFF' as BodyTypeEnum,
    PITBIKE: 'PIT_BIKE' as BodyTypeEnum,
    OTHERMOTO: 'OTHER_MOTO' as BodyTypeEnum,
    OLDOTHERMOTO: 'OLD_OTHER_MOTO' as BodyTypeEnum,
    FLATTRACK: 'FLAT_TRACK' as BodyTypeEnum,
    MOTORCROSS: 'MOTORCROSS' as BodyTypeEnum,
    MINICROSS: 'MINICROSS' as BodyTypeEnum,
    QUADRICICLO: 'QUADRICICLO' as BodyTypeEnum,
    TRIKE: 'TRIKE' as BodyTypeEnum,
  };
  export type PospneEnum = 'A' | 'P' | 'B' | 'Q';
  export const PospneEnum = {
    A: 'A' as PospneEnum,
    P: 'P' as PospneEnum,
    B: 'B' as PospneEnum,
    Q: 'Q' as PospneEnum,
  };
}
